import React from "react";
import { Section, SectionHeading } from "./Section";
import { frameworkSteps } from "../data/framework";
export function FrameworkSection() {
  return <Section tone="navy" labelledBy="framework-title" cta="I want the 6-step framework" data-id="element-150" data-mp="3gahn6hfnpyta">
      <SectionHeading id="framework-title" dark eyebrow="The Facelift Blueprint™ Framework" title={<>
            One case. Six stages. <span className="text-gold-light" data-id="element-152" data-mp="2slye3zos9i05">A more organized educational review.</span>
          </>} sub="Instead of jumping between lectures, notes, articles, and surgical references, use the same structured framework every time you study a case." data-id="element-151" data-mp="32cksjqkrk2h9" />

      <ol className="mt-12 grid gap-x-10 gap-y-2 md:grid-cols-3 md:gap-y-10" data-id="element-153" data-mp="2okwe3gn1l1x4">
        {frameworkSteps.map((step, i) => <li key={step.title} className="flex gap-4 border-t border-white/10 py-5 md:block md:py-0 md:pt-6" data-id="element-154" data-mp="29p6s3ihuwose" data-mpi={i}>
            <span className="font-serif text-5xl font-bold leading-none text-gold md:text-6xl" aria-hidden="true" data-id="element-155" data-mp="2emqej5opk7vf">
              {i + 1}
            </span>
            <div className="md:mt-3" data-id="element-156" data-mp="ss5umak89xoo">
              <h3 className="text-lg font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-157" data-mp="sr49fd9hzut8">{step.title}</h3>
              <p className="mt-1.5 text-[15px] leading-relaxed text-white/75" data-id="element-158" data-mp="16r5bgw1i18aa">{step.body}</p>
            </div>
          </li>)}
      </ol>

      <p className="mx-auto mt-10 max-w-2xl text-center text-lg font-medium text-white" data-id="element-159" data-mp="f098cn58qi07">
        The result is a repeatable educational workflow you can use to structure your study sessions.
      </p>
    </Section>;
}